// Pure scale helpers for the horizontal stacked bar chart, kept free of d3 /
// React / CSS imports so the normalised-vs-magnitude math is unit-testable
// without rendering the chart.

const sumSegments = (segments: Record<string, number>) =>
  Object.values(segments).reduce((sum, value) => sum + value, 0);

/**
 * The stacked value for one segment. Normalised charts stack each bar's
 * segments as fractions of that bar, so every bar fills the axis (composition
 * view). Magnitude charts (`normalized: false`) stack the raw values, so bar
 * length encodes the absolute total — useful for ranked "top contributors"
 * breakdowns where the point is comparing magnitudes, not just proportions.
 */
export const stackedSegmentValue = (
  segments: Record<string, number>,
  key: string,
  normalized: boolean
): number => {
  // @ts-ignore noUncheckedIndexedAccess
  const value: number = segments[key] ?? 0;
  if (!normalized) return value;
  const total = sumSegments(segments);
  return total ? value / total : 0;
};

/**
 * The segment's share of its own bar (0–1), used for the tooltip percentage so
 * it reads correctly in magnitude mode too.
 */
export const stackedSegmentShare = (
  segments: Record<string, number>,
  key: string
): number => {
  const total = sumSegments(segments);
  // @ts-ignore noUncheckedIndexedAccess
  const value: number = segments[key] ?? 0;
  return total ? value / total : 0;
};
